import React from "react";
import Header from "../components/comparateur/Header";
import HeroSection from "../components/comparateur/HeroSection";
import MovingSection from "../components/comparateur/MovingSection";
import CounterSection from "../components/comparateur/CounterSection";
import FeaturesSection from "../components/comparateur/FeaturesSection";
import FinalCTA from "../components/comparateur/FinalCTA";
import Footer from "../components/comparateur/Footer";
import CookieBanner from "../components/comparateur/CookieBanner";
import StickyBar from "../components/comparateur/StickyBar";

const Comparateur = () => {
  return (
    <div className="min-h-screen pb-[60px]" style={{ backgroundColor: "var(--me-bg)" }}>
      <Header />
      <main>
        <HeroSection />
        <MovingSection />
        <CounterSection />
        <FeaturesSection />
        <FinalCTA />
        <Footer />
      </main>
      <CookieBanner />
      <StickyBar />
    </div>
  );
};

export default Comparateur;
